const e = Object.freeze({
  DOWN: 40,
  ENTER: 13,
  ESCAPE: 27,
  LEFT: 37,
  SPACE: 32,
  RIGHT: 39,
  UP: 38
}), D = {
  DEFAULT: "YYYY-MM-DD hh:mm A",
  MONTH_DAY_YEAR_AT_TIME: "MMM DD, YYYY @ h:mmA",
  YYYY_MM_DD: "YYYY-MM-DD",
  YYYY_MM_DD_DATE_FNS: "yyyy-MM-dd",
  YYYY_MM_DD_TIME_DATE_FNS: "yyyy-MM-dd hh:mm aa",
  TIME_DATE_FNS: "hh:mm aa",
  YYYY_MM_DD_SLASHES: "YYYY/MM/DD"
}, t = 3e3, E = Object.freeze({
  SLOW: 3e3,
  MEDIUM: 1e3,
  FAST: 200
}), a = 'button, [href]:not(use), input, select, textarea, [tabindex]:not([tabindex="-1"])', S = Object.freeze({
  ADU: "tw-bg-blue-500",
  BULK: "tw-bg-ice-900",
  REC: "tw-bg-blue-500",
  MED: "tw-bg-yellow-500",
  COM: "tw-bg-royal-500",
  ANC: "tw-bg-orange-500",
  CAN: "tw-bg-green-500"
}), o = {
  GRID_GUTTER: "grid-gutter",
  TOP_HEADER_HEIGHT: "height-topbar"
}, n = {
  MARKETPLACE: "marketplace",
  PAYMENTS: "payments"
}, r = {
  APPLY: "apply",
  LOAD: "load",
  PAGE: "page",
  RESET: "reset",
  SEARCH: "search",
  SORT: "sort"
}, M = Object.freeze({
  AED: "د.إ",
  AFN: "؋",
  ALL: "L",
  AMD: "֏",
  ANG: "ƒ",
  AOA: "Kz",
  ARS: "$",
  AUD: "$",
  AWG: "ƒ",
  AZN: "₼",
  BAM: "KM",
  BBD: "$",
  BDT: "৳",
  BGN: "лв",
  BHD: ".د.ب",
  BIF: "FBu",
  BMD: "$",
  BND: "$",
  BOB: "$b",
  BOV: "BOV",
  BRL: "R$",
  BSD: "$",
  BTC: "₿",
  BTN: "Nu.",
  BWP: "P",
  BYN: "Br",
  BYR: "Br",
  BZD: "BZ$",
  CAD: "$",
  CDF: "FC",
  CHE: "CHE",
  CHF: "CHF",
  CHW: "CHW",
  CLF: "CLF",
  CLP: "$",
  CNY: "¥",
  COP: "$",
  COU: "COU",
  CRC: "₡",
  CUC: "$",
  CUP: "₱",
  CVE: "$",
  CZK: "Kč",
  DJF: "Fdj",
  DKK: "kr",
  DOP: "RD$",
  DZD: "دج",
  EEK: "kr",
  EGP: "£",
  ERN: "Nfk",
  ETB: "Br",
  ETH: "Ξ",
  EUR: "€",
  FJD: "$",
  FKP: "£",
  GBP: "£",
  GEL: "₾",
  GGP: "£",
  GHC: "₵",
  GHS: "GH₵",
  GIP: "£",
  GMD: "D",
  GNF: "FG",
  GTQ: "Q",
  GYD: "$",
  HKD: "$",
  HNL: "L",
  HRK: "kn",
  HTG: "G",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "₪",
  IMP: "£",
  INR: "₹",
  IQD: "ع.د",
  IRR: "﷼",
  ISK: "kr",
  JEP: "£",
  JMD: "J$",
  JOD: "JD",
  JPY: "¥",
  KES: "KSh",
  KGS: "лв",
  KHR: "៛",
  KMF: "CF",
  KPW: "₩",
  KRW: "₩",
  KWD: "KD",
  KYD: "$",
  KZT: "₸",
  LAK: "₭",
  LBP: "£",
  LKR: "₨",
  LRD: "$",
  LSL: "M",
  LTC: "Ł",
  LTL: "Lt",
  LVL: "Ls",
  LYD: "LD",
  MAD: "MAD",
  MDL: "lei",
  MGA: "Ar",
  MKD: "ден",
  MMK: "K",
  MNT: "₮",
  MOP: "MOP$",
  MRO: "UM",
  MRU: "UM",
  MUR: "₨",
  MVR: "Rf",
  MWK: "MK",
  MXN: "$",
  MXV: "MXV",
  MYR: "RM",
  MZN: "MT",
  NAD: "$",
  NGN: "₦",
  NIO: "C$",
  NOK: "kr",
  NPR: "₨",
  NZD: "$",
  OMR: "﷼",
  PAB: "B/.",
  PEN: "S/.",
  PGK: "K",
  PHP: "₱",
  PKR: "₨",
  PLN: "zł",
  PYG: "Gs",
  QAR: "﷼",
  RMB: "￥",
  RON: "lei",
  RSD: "Дин.",
  RUB: "₽",
  RWF: "R₣",
  SAR: "﷼",
  SBD: "$",
  SCR: "₨",
  SDG: "ج.س.",
  SEK: "kr",
  SGD: "S$",
  SHP: "£",
  SLL: "Le",
  SOS: "S",
  SRD: "$",
  SSP: "£",
  STD: "Db",
  STN: "Db",
  SVC: "$",
  SYP: "£",
  SZL: "E",
  THB: "฿",
  TJS: "SM",
  TMT: "T",
  TND: "د.ت",
  TOP: "T$",
  TRL: "₤",
  TRY: "₺",
  TTD: "TT$",
  TVD: "$",
  TWD: "NT$",
  TZS: "TSh",
  UAH: "₴",
  UGX: "USh",
  USD: "$",
  UYI: "UYI",
  UYU: "$U",
  UYW: "UYW",
  UZS: "лв",
  VEF: "Bs",
  VES: "Bs.S",
  VND: "₫",
  VUV: "VT",
  WST: "WS$",
  XAF: "FCFA",
  XBT: "Ƀ",
  XCD: "$",
  XOF: "CFA",
  XPF: "₣",
  XSU: "Sucre",
  XUA: "XUA",
  YER: "﷼",
  ZAR: "R",
  ZMW: "ZK",
  ZWD: "Z$",
  ZWL: "$"
}), R = {
  CLOUDINARY: "https://res.cloudinary.com/leaflink/image/fetch"
}, N = {
  CURRENCY: 2
}, l = Object.freeze({
  NONE: {
    id: "None",
    displayName: ""
  },
  ADULT_USE: {
    id: "Adult Use",
    displayName: "Recreational"
  },
  MEDICAL: {
    id: "Medical",
    displayName: "Medical"
  },
  COMBINED: {
    id: "Combined",
    displayName: "Recreational"
  },
  CANNABIS: {
    id: "Cannabis",
    displayName: "Recreational"
  }
}), i = Object.freeze({
  COMPLETE: {
    color: "tw-bg-purple-500",
    id: "complete"
  },
  PENDING: {
    color: "tw-bg-orange-500",
    id: "pending"
  },
  IGNORED: {
    color: "tw-bg-red-500",
    id: "ignored"
  }
}), A = Object.freeze({
  SUBMITTED: {
    color: "ice-700",
    name: "submitted",
    transitionName: "submit"
  },
  ACCEPTED: {
    color: "green",
    name: "accepted",
    transitionName: "accept"
  },
  FULFILLED: {
    color: "royal",
    name: "fulfilled",
    transitionName: "fulfill"
  },
  SHIPPED: {
    color: "blue",
    name: "shipped",
    transitionName: "ship"
  },
  COMPLETE: {
    color: "purple",
    name: "complete",
    transitionName: "complete"
  },
  REJECTED: {
    color: "red",
    name: "rejected",
    transitionName: "reject"
  },
  CANCELLED: {
    color: "red",
    name: "cancelled",
    transitionName: "cancel"
  },
  DRAFT: {
    color: "blue",
    name: "draft",
    transitionName: ""
  },
  BACKORDER: {
    color: "ice",
    name: "backorder",
    transitionName: "backorder"
  },
  COMBINED: {
    color: "ice",
    name: "combined",
    transitionName: "combine"
  }
}), T = Object.freeze({
  eliteSeller: {
    color: "royal",
    id: "elite"
  },
  powerSeller: {
    color: "green",
    id: "power"
  }
}), c = Object.freeze({
  md: "640px",
  // => @media (min-width: 640px) { ... }
  lg: "961px",
  // => @media (min-width: 961px) { ... }
  xl: "1321px",
  // => @media (min-width: 1321px) { ... }
  /**
   * Target only specific breakpoints.
   *
   * Note: These ONLY apply to the screen function in Tailwind, i.e. `@media screen('md:max-lg')`.
   * When using in a class like `class="lg:max-xl:tw-bg-red"`, it will actually generate two
   * media queries nested inside each other like so: `@media (min-width: 961px) { @media (max-width: 1321px) { ... } }`.
   */
  // sm only - use `max-md` instead!
  // md only
  "md:max-lg": { min: "640px", max: "961px" },
  // => @media (min-width: 640px) and (max-width: 961px) { ... }
  // lg only
  "lg:max-xl": { min: "961px", max: "1321px" },
  // => @media (min-width: 961px) and (max-width: 1321px) { ... }
  /**
   * Max breakpoints.
   *
   * Important: Make sure to list max breakpoints in descending order so that they override each other as expected.
   */
  "max-xl": { raw: "not all and (min-width: 1321px)" },
  // => @media (not all and (min-width: 1321px)) { ... }
  "max-lg": { raw: "not all and (min-width: 969px)" },
  // => @media (not all and (min-width: 961px)) { ... }
  "max-md": { raw: "not all and (min-width: 640px)" }
  // => @media (not all and (min-width: 640px)) { ... }
});
export {
  n as APPS,
  o as CSS_VARS,
  M as CURRENCY_SYMBOL_MAP,
  D as DATE_FORMATS,
  E as DEBOUNCE,
  N as DECIMAL_PRECISION,
  a as FOCUS_ELEMENTS_SELECTOR,
  R as IMAGE_PROVIDER_URLS,
  i as INBOUND_LEADS,
  e as KEY_CODES,
  l as LICENSE_CLASSIFICATIONS,
  S as LICENSE_COLORS,
  r as LLLV_CHANGE_TRIGGERS,
  A as ORDER,
  c as SCREEN_SIZES,
  T as SELLER_STATUSES,
  t as UI_TIMEOUT
};
//# sourceMappingURL=constants.js.map
